import { render, staticRenderFns } from "./CouponWindow.vue?vue&type=template&id=65e286d8&scoped=true&"
import script from "./CouponWindow.vue?vue&type=script&lang=js&"
export * from "./CouponWindow.vue?vue&type=script&lang=js&"
import style0 from "./CouponWindow.vue?vue&type=style&index=0&id=65e286d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e286d8",
  null
  
)

export default component.exports